<template>
  <div class="interface-shield">
    <el-card shadow="never">
      <div slot="header">接口屏蔽</div>
      <el-form label-width="180px">
        <el-form-item label="商贴小程序流程">
          <el-switch
            v-model="skip"
            :active-value="true"
            :inactive-value="false"
            active-text="跳过"
            inactive-text="正常执行"
          />
          <div class="tip">开启后，小程序不展示或命中商贴，支付不追加商贴参数，不创建商贴快照。</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getPcreditEmergencySwitch, savePcreditEmergencySwitch } from '@/api/emergency'

export default {
  name: 'Emergencyinterfaceshield',
  data () {
    return {
      skip: false,
      saving: false
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      getPcreditEmergencySwitch().then(res => {
        this.skip = res.data.data.skip === true
      })
    },
    save () {
      this.saving = true
      savePcreditEmergencySwitch({ skip: this.skip })
        .then(() => {
          this.$message.success('保存成功')
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.interface-shield {
  padding: 20px;
}

.tip {
  margin-top: 8px;
  color: #909399;
}
</style>
